// extracted by mini-css-extract-plugin
export default {"page_container":"pagecontent_page_container__S4LTK","page_subcontainer":"pagecontent_page_subcontainer__+F80B","page_content":"pagecontent_page_content__xBc-Q"};